import { render, staticRenderFns } from "./OtpAuthen.vue?vue&type=template&id=2e5a6b24&scoped=true"
import script from "./OtpAuthen.vue?vue&type=script&lang=js"
export * from "./OtpAuthen.vue?vue&type=script&lang=js"
import style0 from "./OtpAuthen.vue?vue&type=style&index=0&id=2e5a6b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5a6b24",
  null
  
)

export default component.exports